/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Combobox } from '@neo4j-ndl/react';

const options = [
  { label: 'Neo4j', value: 'neo4j' },
  { label: 'Aura', value: 'aura' },
  { label: 'Bloom', value: 'bloom' },
];

const Component = () => (
  <div className="n-flex n-flex-col n-gap-token-16">
    {(['small', 'medium', 'large'] as const).map((size) => (
      <div className="n-flex n-flex-col n-gap-token-4" key={size}>
        <p className="n-capitalize">{size}</p>
        <div className="n-flex n-flex-wrap n-items-start n-gap-token-16">
          <Combobox
            label={`${size} single-select`}
            defaultValue={options[0]}
            options={options}
            size={size}
          />
          <Combobox
            label={`${size} multi-select`}
            defaultValue={options.slice(0, 2)}
            isMulti
            options={options}
            size={size}
          />
        </div>
      </div>
    ))}
  </div>
);

export default Component;
